import { Modal, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Content = styled.div``;

function TagWorksInfoModal({ isOpen, onOpen }) {
  const { t } = useTranslation();

  return (
    <Modal
      size="sm"
      title={t('howTagsWork')}
      isOpen={isOpen}
      onRequestClose={onOpen}
      primaryButtonProps={{
        onClick: () => onOpen(false)
      }}
    >
      <Content>
        <Typography variant="body1Bold">{t('whatAreThey')}</Typography>
        <Typography variant="body2">
          <Trans i18nKey="tagWorksInfoModalDesc1" components={{ b: <b /> }} />
        </Typography>
        <Typography style={{ margin: '16px 0 8px' }} variant="body1Bold">
          {t('howCanIUseThem')}
        </Typography>
        <Typography variant="body2">
          <Trans i18nKey="tagWorksInfoModalDesc2" components={{ b: <b />, br: <br /> }} />
        </Typography>
      </Content>
    </Modal>
  );
}

export { TagWorksInfoModal };
